<div class="form-input file-upload uploading" [ngClass]="{
    'uploading': previewImage.length == 0,
    'uploaded': previewImage.length > 0}">
    <label htmlFor="username" class="justify-content-start d-flex">{{label}}
        <span *ngIf="mandatory" class="text-danger">*</span>
    </label>
    <p-fileUpload (onSelect)="fileUplaodStart 
    ($event)" (uploadHandler)="fileUplaodStart($event)" [auto]="true" [multiple]="false">
        <ng-template pTemplate="toolbar">
            <div *ngIf="previewImage.length == 0 && isFileUplaodInProgress === false ">
                <span class="text-info">Browse files</span>
                <span class="text-muted"> or drag and drop</span>
            </div>
            <div *ngIf="previewImage.length == 0 && isFileUplaodInProgress === true ">
                <img src="assets/themes/images/primary-loader.gif" width="40" height="40" class="loader-image">
            </div>
            <div *ngIf = "previewImage.length > 0">
                <div class="position-relative university-preview mb-3 preview-image" [ngClass]="{
                    'mb-3': previewImage.length == 0}">
                    <a class="cursor-pointer" (click)="removeFile()" src="assets/images/cross.svg" 
                      style="width: 20px;right: 9px;top: 9px;background: #eee;display: block;height: 20px;position: absolute;padding: 4px;border-radius: 50%;line-height: 10px;text-align: center;"
                      ><img  src="assets/images/close-cme.png" /></a>
                    <img [src]="previewImage"
                      onerror="this.src='assets/images/grandround/image_placeholder.svg';" class="h-auto" />
                  </div>
            </div>
        </ng-template>
        <ng-template pTemplate="chooseicon">
            <div *ngIf = "previewImage.length == 0 && isFileUplaodInProgress === false">
                <img class="cursor-pointer" src="assets/images/upload-file.svg" alt="cross">
            </div>
        </ng-template>
    </p-fileUpload>
    <div *ngIf="!errorMessage && invalidFileSizeFlag" class="text-danger">
        {{invalidFileSizeMessage}}
    </div>
    <!-- <div *ngIf="currentUploadedFile" class="mt-1">
        <span>{{currentUploadedFile}}</span>
        <img class="cursor-pointer ml-1" (click)="removeFile()" src="assets/images/cross.svg" alt="cross" width="17" height="17">
    </div> -->
</div>
